<template>
  <div class="messagebox" @click.self="handleMaskClick">
    <div class="content">
      <button
        v-if="closable"
        class="close-btn"
        type="button"
        aria-label="close"
        @click="handleClose"
      >
        ×
      </button>
      <slot>插槽未填写内容</slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "MessageBox",
  props: {
    // 兼容现有用法：<MessageBox :show="show" v-if="show">
    // 并支持 v-model:show 关闭
    show: { type: [Boolean, String, Number], default: true },
    closable: { type: Boolean, default: true },
    closeOnClickMask: { type: Boolean, default: false },
    // 兼容旧代码：很多弹窗传了 :iconShow="true" 并自己渲染 el-icon-close；
    // 这里保留 prop 避免 Vue unknown-prop 警告（实际以 closable 控制是否显示关闭按钮）。
    iconShow: { type: Boolean, default: undefined },
  },
  emits: ["update:show", "close"],
  setup(props, { emit }) {
    const handleClose = () => {
      emit("close");
      emit("update:show", false);
    };

    const handleMaskClick = () => {
      if (props.closeOnClickMask) handleClose();
    };

    return { handleClose, handleMaskClick };
  },
};
</script>
<style scoped lang='scss'>
  .messagebox{
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(9, 9, 9, 0.74);
    z-index: 1000;
    .content{
      position: relative;
    }
    
  }
  .close-btn{
    position: absolute;
    top: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 16px;
    background: rgba(0,0,0,0.06);
    color: #333;
    font-size: 22px;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    z-index: 10;
  }
  .close-btn:hover{
    background: rgba(0,0,0,0.16);
  }
</style>
